module.exports = __webpack_public_path__ + "static/media/datasources.44a3bf32.png";